import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';

import {
    validateAction,
    validateActionDueDate,
    validateActionOutcomeDate,
    validateActionTitle
} from './validationFunctions';

export const validate = (newEntry, contractEndDate, initialStateOnEntry) => {
    let newErrors = {};

    newErrors = validateActionTitle(newEntry.actionTitle, newErrors);
    newErrors = validateAction(newEntry.action, newErrors);
    if (initialStateOnEntry.actionDueDate !== newEntry.actionDueDate)
        newErrors = validateActionDueDate(newEntry.actionDueDate, contractEndDate, newErrors);

    if (initialStateOnEntry.actionOutcomeDate !== newEntry.actionOutcomeDate)
        newErrors = validateActionOutcomeDate(
        newEntry.actionOutcomeDate,
        newEntry.actionStartDate,
        newErrors
    );

    if (Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialStateOnEntry);

    return newErrors;
};